module.exports = __webpack_public_path__ + "files/d0c9c959312dad2b2fdbc9e13fc677c6.png";